import React from "react";

const MAP = {
  New: "bg-blue-50 text-blue-700 border-blue-200",
  "New Requests": "bg-blue-50 text-blue-700 border-blue-200",
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  "Pending Payment": "bg-amber-50 text-amber-700 border-amber-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  pending_payment: "bg-amber-50 text-amber-700 border-amber-200",
  Accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "In Progress": "bg-indigo-50 text-indigo-700 border-indigo-200",
  Preparing: "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Out for Delivery": "bg-cyan-50 text-cyan-700 border-cyan-200",
  Modified: "bg-amber-50 text-amber-700 border-amber-200",
  Delivered: "bg-green-100 text-green-800 border-green-300",
  Completed: "bg-green-100 text-green-800 border-green-300",
  "Mis-delivered": "bg-rose-50 text-rose-700 border-rose-200",
  "Rejected/Cancelled": "bg-rose-50 text-rose-700 border-rose-200",
  "Missed Delivery": "bg-rose-50 text-rose-700 border-rose-200",
  Declined: "bg-rose-50 text-rose-700 border-rose-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  expired: "bg-rose-50 text-rose-700 border-rose-200",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  failed: "bg-rose-50 text-rose-700 border-rose-200",
};

export function StatusBadge({ status, className = "" }) {
  const cls = MAP[status] || "bg-stone-100 text-stone-700 border-stone-200";
  const label = String(status || "").replace(/_/g, " ");
  return (
    <span
      data-testid={`status-badge-${String(status).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize ${cls} ${className}`}
    >
      {label}
    </span>
  );
}
